import { render } from "./LotteryMore.vue?vue&type=template&id=9f96cc76&scoped=true&bindings={}"
import script from "./LotteryMore.vue?vue&type=script&lang=ts"
export * from "./LotteryMore.vue?vue&type=script&lang=ts"

import "./LotteryMore.vue?vue&type=style&index=0&id=9f96cc76&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-9f96cc76"

export default script